type Shape = any;

export class ShapeService {
    private shapes: any;
    private viewer: any;

    constructor() {
        this.shapes = [];
    }

    addShape(shape: Shape) {
        this.shapes.push(shape);
        this.viewer.scene.dispatchEvent({
            type: 'shape_added',
            scene: this,
            shape: shape,
        });
    }

    removeShape(shape: Shape) {
        let index = this.shapes.indexOf(shape);
        if (index > -1) {
            this.shapes.splice(index, 1);
            this.viewer.scene.dispatchEvent({
                type: 'shape_removed',
                scene: this,
                shape: shape,
            });
        }
    }

    getShapes() {
        return this.shapes;
    }
}
